/* Collection covers enhance the existing links; clicks always keep their normal destination. */
if (!customElements.get('zenvana-shop-menu')) {
  customElements.define('zenvana-shop-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.preview = this.querySelector('[data-collection-preview]');
      this.image = this.querySelector('[data-preview-image]');
      this.label = this.querySelector('[data-preview-label]');
      this.defaultLabel = this.label.textContent;
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.addEventListener('pointerover', event => {
        if (event.pointerType === 'touch') return;
        const link = event.target.closest('[data-style-cover]');
        if (link) this.showCover(link);
      }, options);
      this.addEventListener('focusin', event => {
        const link = event.target.closest('[data-style-cover]');
        if (link) this.showCover(link);
      }, options);
      this.addEventListener('pointerleave', () => {
        if (!this.contains(document.activeElement)) this.resetPreview();
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.resetPreview();
      }, options);
      this.desktop.addEventListener('change', () => this.resetPreview(), options);
      this.closest('details')?.addEventListener('toggle', event => {
        if (!event.target.open) this.resetPreview();
      }, options);
    }

    showCover(link) {
      if (!this.desktop.matches || this.closest('.menu-drawer') || this.activeLink === link) return;
      this.activeLink?.classList.remove('is-previewed');
      this.activeLink = link;
      link.classList.add('is-previewed');
      const cover = new Image();
      cover.onload = () => {
        // A slower image must never overwrite a more recently hovered collection.
        if (this.activeLink !== link || !this.desktop.matches || !this.isConnected) return;
        this.image.src = cover.src;
        this.image.alt = `${link.dataset.styleTitle} wallpaper collection`;
        this.preview.href = link.href;
        this.querySelector('[data-preview-title]').textContent = link.dataset.styleTitle;
        const count = Number(link.dataset.styleCount);
        this.querySelector('[data-preview-count]').textContent = Number.isFinite(count)
          ? `${count} ${count === 1 ? 'design' : 'designs'} · Explore collection`
          : 'Explore collection';
        this.label.textContent = 'Explore the collection';
        this.preview.hidden = false;
        this.classList.add('has-collection-preview');
      };
      cover.onerror = () => {
        if (this.activeLink === link) this.resetPreview();
      };
      cover.src = link.dataset.styleCover;
    }

    resetPreview() {
      this.activeLink?.classList.remove('is-previewed');
      this.activeLink = null;
      this.preview.hidden = true;
      this.classList.remove('has-collection-preview');
      this.label.textContent = this.defaultLabel;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}
